function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "x-white_svg__a",
  width: "931.1%",
  height: "142.3%",
  x: "-415.6%",
  y: "-21.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0.903878063 0 0 0 0 0.947303939 0 0 0 0 0.950973732 0 0 0 1 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "x-white_svg__c",
  width: "142.3%",
  height: "931.1%",
  x: "-21.2%",
  y: "-415.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0.903878063 0 0 0 0 0.947303939 0 0 0 0 0.950973732 0 0 0 1 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "x-white_svg__b",
  d: "M4.725 0v9.45"
}), /*#__PURE__*/React.createElement("path", {
  id: "x-white_svg__d",
  d: "M9.45 4.725H0"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-45 10.725 2.275)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#x-white_svg__a)",
  xlinkHref: "#x-white_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#FFF",
  xlinkHref: "#x-white_svg__b"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-45 10.725 2.275)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#x-white_svg__c)",
  xlinkHref: "#x-white_svg__d"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#FFF",
  xlinkHref: "#x-white_svg__d"
})));

function SvgXWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default SvgXWhite;